"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var fa_1 = require("react-icons/lib/fa");
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var asRendition_1 = require("../asRendition");
var utils_1 = require("../utils");
var BtnWrapper = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tborder: 0;\n\tbackground: none;\n\tpadding: 4px;\n\tfont-size: 14px;\n\tmargin-left: 5px;\n\tcolor: rgba(0, 0, 0, 0.4);\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n"], ["\n\tborder: 0;\n\tbackground: none;\n\tpadding: 4px;\n\tfont-size: 14px;\n\tmargin-left: 5px;\n\tcolor: rgba(0, 0, 0, 0.4);\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n"])), function (_a) {
    var color = _a.color;
    return (color ? utils_1.darken(color) : 'black');
});
var Base = function (props) {
    return (React.createElement(BtnWrapper, __assign({}, props),
        React.createElement(fa_1.FaClose, null)));
};
exports.default = recompose_1.compose(styled_components_1.withTheme, asRendition_1.default)(Base);
var templateObject_1;
